import React from "react";

import {
  Row,
  Col,
  Box,
  Botao,
  Combo,
  Alerta,
  TipoAlerta,
  CampoEstatico,
  TipoCampoEstatico,
} from "@intechprev/componentes-web";

import { PlanoSaudeService, FuncionarioService } from "../../services";
import { PlanoSaudeEntidade } from "../../entidades";

import { MasterPage, NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";

interface Props { }

interface State {
  dataSelecionada: number;
  datasPlanoSaude: Array<any>;
  planoSaudeLista: Array<PlanoSaudeEntidade>;
  planoSaudeInfo: Array<PlanoSaudeEntidade>;
  nomeUsuario: string;
  erro: string;
}

export class PlanoSaude extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("plano_saude");

  private page = React.createRef<MasterPage>();
  private alert = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      dataSelecionada: 0,
      datasPlanoSaude: [],
      planoSaudeLista: [],
      planoSaudeInfo: [],
      nomeUsuario: "",
      erro: ""
    };
  }

  componentDidMount = async () => {
    await this.page.current.alternarLoading();
    try {
      const planoInfo = await PlanoSaudeService.Buscar();

      if (planoInfo.length > 0) {
        const datas = await PlanoSaudeService.BuscarDatas();

        const dados = await FuncionarioService.Buscar();
        const nomeUsuario = dados.DadosPessoais.NOME_ENTID;

        await this.setState({
          dataSelecionada: datas[0].ANO_CALENDARIO,
          datasPlanoSaude: datas,
          planoSaudeLista: planoInfo,
          nomeUsuario,
        });

        await this.selecionarPlano();
      }
    } catch (e) {
      const err: any = e;
      const erro = err.response ? err.response.data : err;
      this.setState({ erro });
    }
    finally {
      await this.page.current.alternarLoading();
    }
  };

  condicaoCarregarPlano = () => {
    return this.state.planoSaudeLista.length > 0;
  };

  selecionarPlano = async () => {
    try {
      let planoLista = null;

      /* O ano vem da base como tipo number, mas o Combo
         salva como tipo string */
      let tempData: any = this.state.dataSelecionada;
      if (typeof tempData === "string") {
        tempData = parseInt(tempData, 10);
      }

      if (tempData)
        planoLista = this.state.planoSaudeLista.filter((plano: any) => plano.ANO_CALENDARIO === tempData);
      else planoLista = this.state.planoSaudeLista;

      await this.setState({
        planoSaudeInfo: planoLista,
        dataSelecionada: planoLista[0].ANO_CALENDARIO,
      });
    } catch (e) {
      const err: any = e;
      const erro = err.response ? err.response.data : err;
      this.setState({ erro });
    }
  };

  baixarInforme = async () => {
    await this.alert.current.limparErros();
    try {
      const relatorio = await PlanoSaudeService.GerarRelatorio(
        this.state.dataSelecionada
      );

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(
          new Blob([relatorio]),
          `informe plano de saude - ${this.state.dataSelecionada}.pdf`
        );
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `informe plano de saude - ${this.state.dataSelecionada}.pdf`
        );
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      const e: any = err;
      const Error = e.response ? e.response.data : e;
      await this.alert.current.adicionarErro(typeof Error === "object" ? await Error.text() : Error);
    }
  };

  renderSelecionarAno = () => {
    return (
      <Box>
        <Combo
          contexto={this}
          tamanhoCampo={"2"}
          titulo={"Selecione um Ano Calendário"}
          tamanhoTitulo={"3"}
          onChange={this.selecionarPlano}
          nome={"dataSelecionada"}
          valor={this.state.dataSelecionada}
          opcoes={this.state.datasPlanoSaude}
          nomeMembro={"ANO_CALENDARIO"}
          valorMembro={"ANO_CALENDARIO"}
          padrao={this.state.datasPlanoSaude[0].ANO_CALENDARIO}
        />
      </Box>
    );
  };

  renderPlanoInfoHeader = () => {
    return (
      <Row>
        <Col className={"text-center"}>
          {`Informamos para os devidos fins que ${this.state.nomeUsuario} é titular beneficiário do Plano de Saúde MEDISERVICE (Mediservice Administradora de Planos de Saúde) e foi descontado em folha de pagamento processada pela PREVIRB (Fundação de Previdência dos Servidores do Instituto de Resseguros do Brasil) no ano de ${this.state.dataSelecionada}, o valor total referente ao plano de Saúde conforme abaixo:`}
        </Col>
      </Row>
    );
  };

  renderPlanoInfo = () => {
    const tempInfo = this.state.planoSaudeInfo.map((info: any, index: number) => {
      return (
        <tr key={index}>
          <td>{info.NOME}</td>
          <td>{info.CPF}</td>
          <td>{info.GRAU_PARENT ? "DEPENDENTE" : "TITULAR"}</td>
          <td>
            <CampoEstatico
              valor={info.VALOR}
              tipo={TipoCampoEstatico.dinheiro}
            />
          </td>
        </tr>
      );
    });

    return (
      <Row>
        <Col>
          <table className={"table table-striped table-sm"}>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CPF</th>
                <th>Vínculo</th>
                <th>Valor Total no Ano</th>
              </tr>
            </thead>
            <tbody>{tempInfo}</tbody>
          </table>
        </Col>
      </Row>
    );
  };

  renderPlanoInfoBox = () => {
    return (
      <Box>
        {this.renderPlanoInfoHeader()}
        {this.renderPlanoInfo()}
        <Alerta tipo={TipoAlerta.danger} ref={this.alert} />
        <Botao
          usaLoading
          onClick={this.baixarInforme}
          titulo={"Baixar Informe Plano de Saúde"}
        />
      </Box>
    );
  };

  renderComPlano = () => {
    return (
      <>
        {this.renderSelecionarAno()}
        {this.renderPlanoInfoBox()}
      </>
    );
  };

  renderSemPlano = () => {
    return (
      <Alerta
        tipo={TipoAlerta.danger}
        mensagem={"Informe de Plano de Saúde não disponível."}
      />
    );
  };

  render() {
    return (
      <MasterPage
        Funcionalidade={NumFuncionalidade.INFORME_PLANO_DE_SAÚDE}
        {...this.props}
        ref={this.page}
      >
        <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />

        {this.condicaoCarregarPlano()
          ? this.renderComPlano()
          : this.renderSemPlano()}
      </MasterPage>
    );
  }
}
